import Size11 from '../assets/Plugin/size-1-1.svg';
import Size169 from '../assets/Plugin/size-16-9.svg';
import Size34 from '../assets/Plugin/size-3-4.svg';
import Size43 from '../assets/Plugin/size-4-3.svg';
import Size916 from '../assets/Plugin/size-9-16.svg';

export enum PluginType {
  chat_image = 1, // 聊天发图
  sing = 2, // 唱歌
  search = 3, // 搜索
}

export enum ImageSize {
  three_four = 0, // 3:4，默认值
  four_three = 1, // 4:3
  one_one = 2, // 1:1
  sixteen_nine = 3, // 16:9
  nine_sixteen = 4, // 9:16
}

export const ImageSizeMap = {
  [ImageSize.three_four]: {
    text: '3:4',
    icon: Size34,
  },
  [ImageSize.four_three]: {
    text: '4:3',
    icon: Size43,
  },
  [ImageSize.one_one]: {
    text: '1:1',
    icon: Size11,
  },
  [ImageSize.sixteen_nine]: {
    text: '16:9',
    icon: Size169,
  },
  [ImageSize.nine_sixteen]: {
    text: '9:16',
    icon: Size916,
  },
};

export interface ChatImagePluginSettings {
  size?: ImageSize[]; // 用户选取的画风尺寸。当前最多为1项，未来可能拓展到多项
  style_name: string[]; // 用户选取的画风名。当前最多为1项，未来可能拓展到多项
}

export interface PluginInfo {
  plugin_type: PluginType; // 插件类型
  prompt: string; // 用户输入的prompt
  chat_image_plugin_settings?: ChatImagePluginSettings; // 聊天插件属性
}

export enum ServerRoleType {
  NPC = 1,
  User = 2,
}

// 插件示例对话，跟端上之前使用的示例对话可能有区别，不复用了就
export interface PluginDemoDialogue {
  role_type: ServerRoleType; // 已有结构，NPC=1，USER=2
  message?: string;
  attachment_image_url?: string; // 图像链接
}

export interface AvatarStyleElem {
  avatar_style_name: string;
  avatar_style_img_url: string;
}

export interface ChatImageWebSettings {
  image_size_list: ImageSize[]; // 允许的图像尺寸大小列表
  picture_style_list: AvatarStyleElem[]; // 允许的画风列表，已有的结构
}

export interface PluginDescription {
  plugin_type: PluginType;
  icon_url: string;
  title: string;
  sub_title: string;
  desc: string;
  already_online: boolean;
  demo_dialogue: PluginDemoDialogue[];
  chat_image_web_settings?: ChatImageWebSettings; // 图像插件特有的设置
  warning_msg?: string;
}

export interface IGetWorkspacePluginListReq {}
export interface IGetWorkspacePluginListResp {
  plugin_descriptions: PluginDescription[];
}
